import { Component } from '@angular/core';

@Component({
  selector: 'app-technology-component',
  templateUrl: './technology.component.html',
  styleUrls: ['./technology.component.css']
})
export class TechnologyComponent {
  public currentCount = 0;

  public incrementTechnology() {
    this.currentCount++;
  }
}
